import { render, staticRenderFns } from "./CountriesView.vue?vue&type=template&id=49cd7312&scoped=true"
import script from "./CountriesView.vue?vue&type=script&lang=js"
export * from "./CountriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd7312",
  null
  
)

export default component.exports